import { render, staticRenderFns } from "./TagAnnotateForm.vue?vue&type=template&id=11321c50"
import script from "./TagAnnotateForm.vue?vue&type=script&lang=js"
export * from "./TagAnnotateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports